import { applyMiddleware, combineReducers, createStore } from 'redux'
import thunk from 'redux-thunk'
import createLogger from 'redux-logger'
import moment from 'moment'
import { getLocalStorageItem, setLocalStorageItem } from '../lib/localStorage'

import pages from './pages'
import prismic from './prismic'
import projects from './projects'
import session from './session'
import site from './site'

const middleware = process.env.NODE_ENV === 'production'
  ? [thunk]
  : [thunk, createLogger()]

export const configureStore = (initialState = {}) => (
  createStore(
    combineReducers({
      pages,
      prismic,
      projects,
      session,
      site
    }),
    initialState,
    applyMiddleware(...middleware)
  )
)

export const configureClientStore = (initialState = {}) => {
  const storedState = getLocalStorageItem('app-state')

  const finalInitialState = {
    ...initialState,
    ...storedState
  }

  const store = configureStore(
    filterPreviewToken(finalInitialState)
  )

  store.subscribe(() => {
    const { prismic, session } = store.getState()
    setLocalStorageItem('app-state', { prismic, session })
  })

  return store
}

const filterPreviewToken = (state) => {
  const valid = state.prismic && state.prismic.previewToken && moment(state.prismic.expiry).isAfter(moment())
  return valid ? state : { ...state, prismic: {} }
}



// WEBPACK FOOTER //
// ./store/index.js